<template>
  <div class="page-head">
    <div class="d-flex justify-content-between align-items-center">
      <div class="d-flex">
        <h3>{{ title }}</h3>
        <div class="ml-2 mt-1">
          <slot name="left"> </slot>
        </div>
      </div>

      <div class="pull-right">
        <slot name="right"> </slot>
      </div>
    </div>
    <b-link
      v-for="(tab, index) in tabs"
      :key="`${tab.routeName}_${index}`"
      class="mr-4 d-inline-block"
      @click="persistHash"
      :to="{
        name: tab.routeName,
        params: tab.routeParams,
        query: tab.queryParams,
      }"
      :class="activeFunc(tab) ? 'active-page-tab' : ''"
    >
      {{ tab.title }}
    </b-link>
  </div>
</template>

<script>
export default {
  props: {
    tabs: null,
    title: {
      required: true,
      type: String,
    },
    activeFn: {
      type: Function,
      default: null,
    },
  },
  data() {
    return {
      currentHash: "",
    };
  },
  created() {
    document.title = this.title;
    this.currentHash = window.location.hash;
  },
  computed: {
    activeFunc() {
      return this.activeFn
        ? this.activeFn
        : (tab) => this.$route.name == tab.routeName;
    },
  },
  methods: {
    persistHash() {
      this.$eventHub.$emit("persist-hash", this.currentHash);
    },
  },
  watch: {
    title() {
      document.title = this.title;
    },
  },
};
</script>
